module.exports = __webpack_public_path__ + "img/slide-1.54838b8f.png";